<template>
  <div>
      <template> <!--  v-if="!isLoading" -->
        <div class="dashboard-links">
          <v-container class="grey lighten-5">
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="6">
                <v-card class="pa-2" outlined tile>
                  PERSONAL DETAILS
                  <!--MODAL--->
                  <div>
                    <button class="add-btn" @click="$bvModal.show('contactNo-modal')"
                      >ADD YOUR CONTACT NUMBER</button
                    >
                    <!--LINK TO MODAL - CREATE UNIT PRODUCT - URL: units/unitId/productId-->
                    <b-modal id="contactNo-modal" hide-footer>
                      <template v-slot:modal-title>
                        Add a your contact number
                      </template>
                      <SupportDetailsModal />
                    </b-modal>
                  </div>
                  <!--END OF MODAL-->
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
  </div>

    <!-- <p v-else>
      Loading products
    </p> -->
  <!-- </div> -->
</template>

<script>
// import ProductService from '@/services/ProductService.js'

import SupportDetailsModal from '@/components/ui/SupportDetailsModal.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
    SupportDetailsModal
  },
  data() {
    return {
      isLoading: true,
      products: [],
      prodInfo: null,
      loading: true,
      errored: false
    }
  }
}
</script>

<style lang="css" scoped>
.add-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  width: 60%;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
}

</style>
